import { useEffect, useState } from 'react'
import MuiTypography from '@mui/material/Typography'
import { DataGridPro as DataGrid, GridToolbar } from '@mui/x-data-grid-pro'
import { useGetImportRecordsQuery } from '../slice'
import { useGetFieldsQuery } from '../../../services/fields/slice'
import { LicenseInfo } from '@mui/x-license-pro'
import AppConfig from '../../../config'

LicenseInfo.setLicenseKey(AppConfig.mui.licenseKey)

const PreviewImport = ({ imported }) => {
  const { data: prospectFields, isFieldsLoading } = useGetFieldsQuery('prospects')
  const { data: importRecords, isRecordsLoading } = useGetImportRecordsQuery({ importId: imported.id })
  const [columns, setColumns] = useState([])
  const [rows, setRows] = useState([])

  useEffect(() => {
    if (prospectFields) {
      const cols = imported.fields
        .map((importedField) => {
          const prospectColumn = prospectFields.find(
            (prospectField) => prospectField.name === importedField.mappedField
          )
          if (!prospectColumn && !importedField.ignore)
            return {
              field: importedField.mappedField,
              headerName: importedField.mappedField,
              width: '200',
              editable: true,
            }
          return !importedField.ignore
            ? {
                field: importedField.mappedField,
                headerName: prospectColumn.label,
                description: prospectColumn.description,
                width: '200',
                editable: !prospectColumn.isReadOnly,
              }
            : null
        })
        .filter((column) => column)
        .sort((a, b) => a.headerName.localeCompare(b.headerName))
      setColumns(cols)
    }
  }, [prospectFields, imported.fields])

  useEffect(() => {
    if (importRecords) {
      const mappedFields = imported.fields.filter((field) => !field.ignore)
      mappedFields.push({ ignore: false, mappedField: 'id', incomingColumn: 'id' })
      const rows = importRecords.map((record) => {
        return mappedFields.reduce((acc, field) => {
          acc[field.mappedField] = record[field.incomingColumn]
          return acc
        }, {})
      })
      setRows(rows)
    }
  }, [importRecords, imported.fields])

  return (
    <>
      <MuiTypography>Previewing. Import when ready.</MuiTypography>
      {(isFieldsLoading || isRecordsLoading) && <MuiTypography>Loading...</MuiTypography>}
      {prospectFields && importRecords && (
        <DataGrid
          rows={rows}
          columns={columns}
          density="compact"
          pagination
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 25,
              },
            },
          }}
          slots={{
            toolbar: GridToolbar,
          }}
          pageSizeOptions={[25, 50, 100]}
          checkboxSelection
          disableRowSelectionOnClick
        />
      )}
    </>
  )
}

export default PreviewImport
